import { render, staticRenderFns } from "./receipt-price-template.vue?vue&type=template&id=a0ec1e2e&scoped=true"
import script from "./receipt-price-template.vue?vue&type=script&lang=js"
export * from "./receipt-price-template.vue?vue&type=script&lang=js"
import style0 from "./receipt-price-template.vue?vue&type=style&index=0&id=a0ec1e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ec1e2e",
  null
  
)

export default component.exports